<template>
  <mw-dialog :size="params.size?params.size:'small_small'" customClass="mw-dialog-tree-table" ref="dialog"
             :title="params.title?params.title:'选择'" :appendToBody="false" :footerButton="footerButton"
             :before-close="selectCancel">
    <mw-table ref="dataTable" :columns="params.columns ? params.columns:columns" :defaultParamsAutoLoad="true"
              :pagination="params.pagination==undefined?false:params.pagination" :defaultParams="params.defaultParams==undefined?{}:params.defaultParams"
            :data="params.data"  :api="params.api" :singleSelect="params.singleSelect">
    </mw-table>
  </mw-dialog>
</template>

<script>
  export default {
    props: {
      /**
       *  params.data
       *
       *  size:弹出框大小   （可选、默认small_small）
       *  title:弹出框标题  （可选、默认标题）
       *  sureName: 确定按钮名称 （可选、默认确定）
       *  cancelName: 取消按钮名称 （可选、默认取消）
       *  clearBtn: true为启用清除按钮，默认无
       *
       *  singleSelect:是否单选（可选、默认多选）
       *
       *  api:  获取数据地址
       *  data: 列表数据
       *  注：api,data二选其一，优先data
       *
       *  columns: 列定义 (默认,有name列)
       *  defaultParams:获取参数
       *  pagination:是否分页 默认不分页
       *
       *  func 回调函数
       *
       */
      params: {
        type: Object
      }
    },
    data() {
      let me = this;
      return {
        api: '',
        columns: [{type: 'selection'},
          {prop: 'name', label: '名称', tooltip: true}],

        footerButton: [
          {label: me.params.cancelName || '取消', func: this.selectCancel, type: 'default'},
          {label: me.params.sureName || '确定', func: this.selectSure,}
        ]
      }
    },
    created() {
      let me = this;
      if (me.params.buttonsScript)
        eval(me.params.buttonsScript);

      if (me.params.clearBtn != undefined && me.params.clearBtn) {
        this.footerButton.unshift({
          label: '清除',
          func: this.clearSure,
          type: 'default'
        })
      }
    },
    mounted() {
      setTimeout(() => {
        this.show();
      }, 200)
    },

    methods: {
      selectSure() {
        let me = this, data = me.mwRef('dataTable').getMultipleSelection();
        me.params.func(data);
        me.selectCancel();
      },

      selectCancel() {
        this.mwRef('dialog').hide();
      },

      clearSure() {
        let me = this;
        me.params.func([]);
        me.selectCancel();
      },

      show() {
        this.mwRef('dialog').show();
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/components/table.vue